import { createContext } from 'react'

import type { AccountPreferences, OrganizationsDetail, Role } from '@ankor-io/common/types/account'

import type { UserContextType } from './types'

export type UserContextValue = {
  user: UserContextType | null
  isLoading: boolean
  organizations: OrganizationsDetail
  activeOrganizationId: string | null
  activeVesselId: string | null
  activeConnectedAccountId: string | null
  activeOrganizationRole: Role
  preferences: AccountPreferences
  /**
   * Update the organization name and description by id in the user context
   * @param orgId - The ID of the organization to update
   * @param name - The new name of the organization
   * @param description - The new description of the organization
   */
  updateOrganization: (orgId: string, name: string, description: string) => void
  updateActiveOrganizationId: (orgId: string) => void
  updateActiveVesselId: (vesselId: string) => void
  updateActiveConnectedAccountId: (connectedAccountId: string, skipPreferencesUpdate?: boolean) => void
  updatePreferences: (preferences: AccountPreferences) => Promise<void>
}

export const UserContext = createContext<UserContextValue | null>(null)
